import React from 'react';

import { StatusEntity } from 'types/lead-management';

interface LeadStatusTagProps {
  status?: StatusEntity;
  className?: string;
}

const hexToRgba = (hex: string, opacity: number): string => {
  const cleanHex = hex.replace('#', '');
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

const LeadStatusTag: React.FC<LeadStatusTagProps> = ({
  status,
  className = ''
}) => {
  const { color = '#f4f4f4', value } = status || {};
  return (
    <div
      className={`text-14 flex items-stretch gap-1.5 text-sm font-medium text-gray-700  ${className}`}
    >
      <div
        className="flex-1 truncate !rounded-lg px-2 py-1 text-center"
        style={{
          color,
          backgroundColor: hexToRgba(color, 0.1),
          maxWidth: '157px'
        }}
        title={value}
      >
        {value}
      </div>
    </div>
  );
};

export default LeadStatusTag;
